<div class="searchControl">
    <input type="search" class="form-control rounded" placeholder="Search" aria-label="Search" (change)="changeEvent($event)"/>
    <span class="input-group-text border-0" id="search-addon">
        <i class="fa fa-search"></i>
    </span>
</div>

